import {AUTH} from '../constants';

export const fetchCaptcha = () => {
    return {
        type: AUTH.FETCH_CAPTCHA
    }
}

export const fetchCaptchaLoad = () => {
    return {
        type: AUTH.FETCH_CAPTCHA_LOAD
    }
}

export const fetchCaptchaSuccess = (captchaImage) => {
    return {
        type: AUTH.FETCH_CAPTCHA_SUCCESS,
        captchaImage: captchaImage
    }
}

export const fetchCaptchaFail = error => {
    return {
        type: AUTH.FETCH_CAPTCHA_FAIL,
        error: error
    }
}


export const login = (formData) => {
    return {
        type: AUTH.LOGIN,
        formData: formData
    }
}

export const loginLoad = () => {
    return {
        type: AUTH.LOGIN_LOAD
    }
}

export const loginSuccess = (token, user) => {
	sessionStorage.setItem('token', token);
	sessionStorage.setItem('user', user);
    return {
        type: AUTH.LOGIN_SUCCESS,
    }
}

export const loginFail = error => {
    return {
        type: AUTH.LOGIN_FAIL,
        error: error
    }
}


export const logout = () => {
	sessionStorage.removeItem('token');
	sessionStorage.removeItem('user');
    return {
        type: AUTH.LOGOUT
    }
}
